import styled from "styled-components";

export const Fullscreen = styled.div.attrs({
  className: "fullscreen w-100",
})``;
